import { AxiosResponse } from 'axios';
import { HttpClient } from '../HttpClient';
import { SignalApiUrls } from '../urls';

export type VersionResponse = {
  apiVersion: string;
  imageTag: string;
};
export default class VersionClient extends HttpClient {
  async getApiVersion(): Promise<AxiosResponse<VersionResponse>> {
    return await this.get<AxiosResponse<VersionResponse>>(
      SignalApiUrls.getApiVersionUrl(),
    );
  }
}
